import { z } from "zod";
// Response schemas are tolerant (z.object strips unknown keys): an API
// deployed before a client may add fields, and the client must keep working.
// Request and input schemas stay strict against mass assignment.
// Shared by the worker (cron registration, archive pruning) and the admin
// service-status route, so the schedule shown to customers is the schedule that runs.
export const PRODUCTION_BACKUP = {
    jobName: "ops.production_backup",
    weekday: 0,
    hour: 4,
    minute: 0,
    timeZone: "Pacific/Auckland",
    intervalDays: 7,
    retainedGenerations: 4,
    encryption: "AES-256-GCM",
    get cron() {
        return `${this.minute} ${this.hour} * * ${this.weekday}`;
    },
};
export const RECORD_RETENTION_YEARS = 4;
export const BACKUP_STATES = [
    "on_schedule",
    "overdue",
    "last_attempt_failed",
    "none_recorded",
];
export const ServiceStatusResponseSchema = z.object({
    generated_at: z.iso.datetime({ offset: true }),
    billing_mode: z.enum(["pilot", "stripe"]),
    hosting: z.object({ api_sleeps_when_idle: z.boolean() }),
    backups: z.object({
        frequency: z.enum(["weekly", "daily"]),
        weekday: z.number().int().min(0).max(6),
        local_time: z.string().regex(/^\d{2}:\d{2}$/),
        time_zone: z.string(),
        encrypted: z.boolean(),
        retained_generations: z.number().int().positive(),
        max_loss_window_days: z.number().int().positive(),
        state: z.enum(BACKUP_STATES),
        last_success_at: z.iso.datetime({ offset: true }).nullable(),
        last_attempt_at: z.iso.datetime({ offset: true }).nullable(),
        last_attempt_status: z.enum(["running", "succeeded", "failed"]).nullable(),
    }),
    retention: z.object({
        record_years: z.number().int().positive(),
        other_file_years: z.number().int().positive(),
    }),
});
